import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=11347b0e&scoped=true"
import script from "./PrizesPayments.js?vue&type=script&lang=js&external"
export * from "./PrizesPayments.js?vue&type=script&lang=js&external"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=11347b0e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11347b0e",
  null
  
)

export default component.exports